import { lazy } from 'react'
import { Navigate } from 'react-router'
import DashboardLayout from '../layouts/dashboard'
import Loadable from '../components/Loadable'
import AuthGuard from '../auth/AuthGuard'

// OPENPAY -----------------------------------------------------------------------------
const ValidacionOpenPayPage = Loadable(lazy(() => import('../pages/openpay/ValidacionOpenPayPage')))

// -- HOME ------------------------------------------------------------------------------
const HomePage = Loadable(lazy(() => import('../pages/home/HomePage')))

// VENTAS ------------------------------------------------------------------------------------------
const VentasPage = Loadable(lazy(() => import('../pages/ventas/VentasPage')))
const PagosCuentasPage = Loadable(lazy(() => import('../pages/ventas/PagosCuentasPage')))
const CortesCajaPage = Loadable(lazy(() => import('../pages/ventas/CortesCajaPage')))
const FichaCorteCajaPage = Loadable(lazy(() => import('../pages/ventas/FichaCorteCajaPage')))
const DevolucionesPage = Loadable(lazy(() => import('../pages/ventas/DevolucionesPage')))
const EstadoMesasPage = Loadable(lazy(() => import('../pages/ventas/EstadoMesasPage')))
const VentasPorPlatilloPage = Loadable(lazy(() => import('../pages/ventas/VentasPorPlatilloPage')))

// -- GASTOS ------------------------------------------------------------------------------
const GastosPage = Loadable(lazy(() => import('../pages/gastos/GastosPage')))
const FichaGastoPage = Loadable(lazy(() => import('../pages/gastos/FichaGastoPage')))
const CategoriasGastosPage = Loadable(lazy(() => import('../pages/gastos/CategoriasGastosPage')))
const GastosFijosPage = Loadable(lazy(() => import('../pages/gastos/GastosFijosPage')))
const ProveedoresPage = Loadable(lazy(() => import('../pages/gastos/ProveedoresPage')))
const FichaProveedorPage = Loadable(lazy(() => import('../pages/gastos/FichaProveedorPage')))
const MovimientosCuentasPage = Loadable(lazy(() => import('../pages/gastos/MovimientosCuentasPage')))
const FichaMovimientoCuenta = Loadable(lazy(() => import('../pages/gastos/FichaMovimientoCuenta')))

// FACTURACION -------------------------------------------------------------------------------------
const ComprobantesEmitidosPage = Loadable(lazy(() => import('../pages/facturacion/ComprobantesEmitidosPage')))
const ComprobantesRecibidosPage = Loadable(lazy(() => import('../pages/facturacion/ComprobantesRecibidosPage')))
const FacturaGlobalPage = Loadable(lazy(() => import('../pages/facturacion/FacturaGlobalPage')))
const ConexionesSatPage = Loadable(lazy(() => import('../pages/facturacion/ConexionesSatPage')))

// -- ALMACEN ------------------------------------------------------------------------------
const CategoriasInsumosPage = Loadable(lazy(() => import('../pages/almacen/CategoriasInsumosPage')))
const InsumosPage = Loadable(lazy(() => import('../pages/almacen/InsumosPage')))
const FichaInsumoPage = Loadable(lazy(() => import('../pages/almacen/FichaInsumoPage')))
const SubrecetasPage = Loadable(lazy(() => import('../pages/almacen/SubrecetasPage')))
const FichaSubrecetaPage = Loadable(lazy(() => import('../pages/almacen/FichaSubrecetaPage')))
const PanelPedidosPage = Loadable(lazy(() => import('../pages/almacen/PanelPedidosPage')))
const CrearPedidoPage = Loadable(lazy(() => import('../pages/almacen/CrearPedidoPage')))
const FichaPedidoPage = Loadable(lazy(() => import('../pages/almacen/FichaPedidoPage')))
const EditarPedidoPage = Loadable(lazy(() => import('../pages/almacen/EditarPedidoPage')))
const TraspasosPage = Loadable(lazy(() => import('../pages/almacen/TraspasosPage')))
const CrearTraspasoPage = Loadable(lazy(() => import('../pages/almacen/CrearTraspasoPage')))
const ExistenciasPage = Loadable(lazy(() => import('../pages/almacen/ExistenciasPage')))

// -- MENU ------------------------------------------------------------------------------
const CategoriasPlatillosPage = Loadable(lazy(() => import('../pages/menus/CategoriasPlatillosPage')))
const FichaCategoriaPlatilloPage = Loadable(lazy(() => import('../pages/menus/FichaCategoriaPlatilloPage')))
const PlatillosPage = Loadable(lazy(() => import('../pages/menus/PlatillosPage')))
const FichaPlatilloPage = Loadable(lazy(() => import('../pages/menus/FichaPlatilloPage')))
const ModificadoresPage = Loadable(lazy(() => import('../pages/modificadores/ModificadoresPage')))
const FichaModificadorPage = Loadable(lazy(() => import('../pages/modificadores/FichaModificadorPage')))
const FamiliasModificadoresPage = Loadable(lazy(() => import('../pages/familiasModificadores/FamiliasModificadoresPage')))
const FichaFamiliaModificadorPage = Loadable(lazy(() => import('../pages/familiasModificadores/FichaFamiliaModificador')))
const PromocionesPage = Loadable(lazy(() => import('../pages/menus/PromocionesPage')))
const FichaPromocionPage = Loadable(lazy(() => import('../pages/menus/FichaPromocionPage')))
const ActualizadoresPrecios = Loadable(lazy(() => import('../pages/menus/ActualizadoresPrecios')))

// USUARIOS ---------------------------------------------------------------------------
const UsersAdminPage = Loadable(lazy(() => import('../pages/users/UsersAdminPage')))
const UsersClientePage = Loadable(lazy(() => import('../pages/users/UsersClientePage')))
const GruposPermisosPage = Loadable(lazy(() => import('../pages/users/GruposPermisosPage')))
const EditGrupoPermisosPage = Loadable(lazy(() => import('../pages/users/EditGrupoPermisosPage')))

// -- CONFIGURACIONES ------------------------------------------------------------------------------
const ConfiguracionesPage = Loadable(lazy(() => import('../pages/negocio/ConfiguracionesPage')))
const CanalesVentasPage = Loadable(lazy(() => import('../pages/negocio/CanalesVentasPage')))
const FormasPagosPage = Loadable(lazy(() => import('../pages/negocio/FormasPagosPage')))
const CuentasGruposComercialesPage = Loadable(lazy(() => import('../pages/negocio/CuentasGruposComercialesPage')))

// MI CUENTA ---------------------------------------------------------------------------
const MiPerfilPage = Loadable(lazy(() => import('../pages/mi-cuenta/MiPerfilPage'))) 
const SubscripcionPage = Loadable(lazy(() => import('../pages/mi-cuenta/SubscripcionPage'))) 
const ComprarFoliosPage = Loadable(lazy(() => import('../pages/mi-cuenta/ComprarFoliosPage'))) 

// -- CLIENTES ------------------------------------------------------------------------------
const ClientesPage = Loadable(lazy(() => import('../pages/clientes/ClientesPage')))
const EditClientePage = Loadable(lazy(() => import('../pages/clientes/EditClientePage')))

// DISPOSITIVOS -----------------------------------------------------------------------
const DispositivosPage = Loadable(lazy(() => import('../pages/dispositivos/DispositivosPage')))

// TARJETAS RFID -----------------------------------------------------------------------
const TarjetasRfidPage = Loadable(lazy(() => import('../pages/clientes/TarjetasRfidPage')))

// CONTACTOS --------------------------------------------------------------------------
const ContactosPage = Loadable(lazy(() => import('../pages/contactos/ContactosPage')))

// MONEDEROS --------------------------------------------------------------------------
const MonederosPage = Loadable(lazy(() => import('../pages/monederos/MonederosPage')))

// COBRANZA ---------------------------------------------------------------------------
const FacturasClientesPage = Loadable(lazy(() => import('../pages/cobranza/FacturasClientesPage')))
const TransaccionesPage = Loadable(lazy(() => import('../pages/cobranza/TransaccionesPage')))
const AcumuladoCobranzaPage = Loadable(lazy(() => import('../pages/cobranza/AcumuladoCobranzaPage')))

// FOLIOS ---------------------------------------------------------------------------
const FoliosPage = Loadable(lazy(() => import('../pages/folios/FoliosPage')))
const AbonosPage = Loadable(lazy(() => import('../pages/folios/AbonosPage')))

// DISTRIBUIDORES ---------------------------------------------------------------------------
const DistribuidoresPage = Loadable(lazy(() => import('../pages/distribuidores/DistribuidoresPage')))
const EdosCtaDistribuidoresPage = Loadable(lazy(() => import('../pages/distribuidores/EdosCtaDistribuidoresPage')))

// REPORTES ---------------------------------------------------------------------------
const ReportesPage = Loadable(lazy(() => import('../pages/reportes/ReportesPage')))
const BitacorasPage = Loadable(lazy(() => import('../pages/reportes/BitacorasPage')))
const ChequePromedioPage = Loadable(lazy(() => import('../pages/reportes/ChequePromedioPage')))
const MermasPage = Loadable(lazy(() => import('../pages/reportes/MermasPage')))
const ReporteVentasPage = Loadable(lazy(() => import('../pages/reportes/ReporteVentasPage')))
const VentasPlatillosPage = Loadable(lazy(() => import('../pages/reportes/VentasPlatillosPage')))
const VentasEmpleadosPage = Loadable(lazy(() => import('../pages/reportes/VentasEmpleadosPage')))
const ValuacionInventarioPage = Loadable(lazy(() => import('../pages/reportes/ValuacionInventarioPage')))
const VentaVSCostoPage = Loadable(lazy(() => import('../pages/reportes/VentaVSCostoPage')))
const PopularidadYRankingPage = Loadable(lazy(() => import('../pages/reportes/PopularidadYRankingPage')))
const ComprasPage = Loadable(lazy(() => import('../pages/reportes/ComprasPage')))
const GastosOperativosPage = Loadable(lazy(() => import('../pages/reportes/GastosOperativosPage')))
const BalanceFinancieroPage = Loadable(lazy(() => import('../pages/reportes/BalanceFinancieroPage')))
const EstadoSucursalesPage = Loadable(lazy(() => import('../pages/reportes/EstadoSucursalesPage')))

// AJUSTES ---------------------------------------------------------------------------
const CertificadoIrPage = Loadable(lazy(() => import('../pages/configs/CertificadoIrPage')))

// AYUDA -------------------------------------------------------------------------------------------
const VideoTutorialesPage = Loadable(lazy(() => import('../pages/ayuda/VideoTutorialesPage')))

// OPERACION ADMIN ----------------------------------------------------------------------------------
const ActualizacionesLocalesPage = Loadable(lazy(() => import('../pages/operacion/ActualizacionesLocalesPage')))    

// UTILS -------------------------------------------------------------------------------------------
// const ConstruccionPage = Loadable(lazy(() => import('../pages/utils/ConstruccionPage')))

const MainRoutes = {
    path: 'app',
    element: (
        <AuthGuard>
            <DashboardLayout />
        </AuthGuard>
    ),
    children: [
        { path: 'validacion_openpay', element: <ValidacionOpenPayPage /> },
        { path: 'tablero', element: <HomePage /> },
        { 
            path: 'reportes',
            children : [
                { path :'', element : <Navigate to='indice' />},
                { path: 'indice', element: <ReportesPage /> },
                { path: 'bitacora_eventos', element: <BitacorasPage /> },
                { path: 'cheque_promedio', element: <ChequePromedioPage /> },
                { path: 'mermas', element: <MermasPage /> },
                { path: 'ventas', element: <ReporteVentasPage /> },
                { path: 'ventas_por_platillo', element: <VentasPlatillosPage /> },
                { path: 'ventas_por_empleado', element: <VentasEmpleadosPage /> },
                { path: 'valuacion_inventario', element: <ValuacionInventarioPage /> },
                { path: 'ventas_vs_costo', element: <VentaVSCostoPage /> },
                { path: 'popularidad_y_ranking', element: <PopularidadYRankingPage /> },
                { path: 'compras', element: <ComprasPage /> },
                { path: 'gastos_operativos', element: <GastosOperativosPage /> },
                { path: 'balance_financiero', element: <BalanceFinancieroPage /> },
                { path: 'estado_sucursales', element: <EstadoSucursalesPage /> },
            ]
        },
        { 
            path: 'ventas',
            children : [
                { path :'', element : <Navigate to='panel' />},
                { path: 'panel', element: <VentasPage /> },
                { path: 'transacciones', element: <PagosCuentasPage /> },
                { path: 'cortes', element: <CortesCajaPage /> },
                { path: 'ficha_corte_caja/:id', element: <FichaCorteCajaPage /> },
                { path: 'devoluciones', element: <DevolucionesPage /> },
                { path: 'estado_mesas', element: <EstadoMesasPage /> },
                { path: 'ventas_por_platillo', element: <VentasPorPlatilloPage /> },
            ]
        },
        { 
            path: 'gastos',
            children : [
                { path :'', element : <Navigate to='panel' />},
                { path: 'panel', element: <GastosPage /> },
                { path: 'ficha_gasto/:id', element: <FichaGastoPage /> },
                { path: 'categorias', element: <CategoriasGastosPage /> },
                { path: 'fijos', element: <GastosFijosPage /> },
                { path: 'proveedores', element: <ProveedoresPage /> },
                { path: 'ficha_proveedor/:id', element: <FichaProveedorPage /> },
                { path: 'movimientos_cuentas', element: <MovimientosCuentasPage /> },
                { path: 'ficha_movimiento/:id', element: <FichaMovimientoCuenta /> },
            ]
        },
        { 
            path: 'facturacion',
            children : [
                { path :'', element : <Navigate to='emitidos' />},
                { path: 'emitidos', element: <ComprobantesEmitidosPage /> },
                { path: 'recibidos', element: <ComprobantesRecibidosPage /> },
                { path: 'global', element: <FacturaGlobalPage /> },
                { path: 'conexiones_sat', element: <ConexionesSatPage /> },
            ]
        },
        { 
            path: 'almacen',
            children : [
                { path :'', element : <Navigate to='categorias' />},
                { path: 'categorias', element: <CategoriasInsumosPage /> },
                { path: 'insumos', element: <InsumosPage /> },
                { path: 'ficha_insumo/:id', element: <FichaInsumoPage /> },
                { path: 'subrecetas', element: <SubrecetasPage /> },
                { path: 'ficha_subreceta/:id', element: <FichaSubrecetaPage /> },
                { path: 'pedidos', element: <PanelPedidosPage /> },
                { path: 'ficha_pedido/:id', element: <FichaPedidoPage /> },
                { path: 'crear_pedido', element: <CrearPedidoPage /> },
                { path: 'editar_pedido/:id', element: <EditarPedidoPage /> },
                { path: 'traspasos', element: <TraspasosPage /> },
                { path: 'crear_traspaso', element: <CrearTraspasoPage /> },
                { path: 'existencias/', element: <ExistenciasPage /> },
            ]
        },
        { 
            path: 'menu',
            children : [
                { path :'', element : <Navigate to='categorias' />},
                { path: 'categorias', element: <CategoriasPlatillosPage /> },
                { path: 'ficha_categoria_platillo/:id', element: <FichaCategoriaPlatilloPage /> },
                { path: 'modificadores', element: <ModificadoresPage /> },
                { path: 'ficha_modificador/:id', element: <FichaModificadorPage /> },
                { path: 'familias_modificadores', element: <FamiliasModificadoresPage /> },
                { path: 'familia_modificador/:id', element: <FichaFamiliaModificadorPage /> },
                { path: 'platillos_bebidas/:filter?/:categoria_platillo_id?', element: <PlatillosPage /> },
                { path: 'ficha_platillo/:id/:filter?/:categoria_platillo_id?', element: <FichaPlatilloPage /> },
                { path: 'promociones', element: <PromocionesPage /> },
                { path: 'ficha_promocion/:id', element: <FichaPromocionPage /> },
                { path: 'actualizadores_precios', element: <ActualizadoresPrecios /> },
            ]
        },
        { 
            path: 'usuarios',
            children : [
                { path :'', element : <Navigate to='panel' />},
                { path: 'panel', element: <UsersClientePage /> },
                { path: 'permisos', element: <GruposPermisosPage /> },
                { path: 'editar_grupo_permisos/:id', element: <EditGrupoPermisosPage /> },
            ]
        },
        { 
            path: 'negocio',
            children : [
                { path :'', element : <Navigate to='organizacion' />},
                { path: 'organizacion', element: <ConfiguracionesPage /> },
                { path: 'canales_ventas', element: <CanalesVentasPage /> },
                { path: 'formas_pago', element: <FormasPagosPage /> },
                { path: 'cuentas', element: <CuentasGruposComercialesPage /> },
            ]
        },
        {
            path : 'clientes',
            children : [
                { path :'', element : <Navigate to='panel' />},
                { path: 'panel', element: <ClientesPage /> },
                { path: 'editar/:id', element: <EditClientePage /> },
                { path: 'monederos', element: <MonederosPage /> },
                { path: 'dispositivos', element: <DispositivosPage /> },
                { path: 'tarjetas_rfid', element: <TarjetasRfidPage /> },
                { path: 'contactos', element: <ContactosPage /> },
            ]
        },
        {
            path : 'usuarios_adm',
            children : [
                { path: '', element : <Navigate to='panel' />},
                { path: 'panel', element: <UsersAdminPage /> },
            ]
        },
        {
            path : 'cobranza',
            children : [
                { path: '', element : <Navigate to='facturas' /> },
                { path: 'facturas', element: <FacturasClientesPage /> },
                { path: 'transacciones', element: <TransaccionesPage /> },
                { path: 'acumulado', element: <AcumuladoCobranzaPage /> },
            ]
        },
        {
            path : 'folios',
            children : [
                { path: '', element : <Navigate to='panel'/> },
                { path: 'panel', element: <FoliosPage /> },
                { path: 'abonos', element: <AbonosPage />  },
            ]
        },
        {
            path : 'distribuidores',
            children : [
                { path: '', element : <Navigate to='panel' /> },
                { path: 'panel', element: <DistribuidoresPage /> },
                { path: 'edos_cta', element: <EdosCtaDistribuidoresPage /> },
            ]
        },
        {
            path : 'sistema',
            children : [
                { path: '', element : <Navigate to='certificado' /> },
                { path: 'certificado', element: <CertificadoIrPage /> },
            ]
        },
        { path : 'mi_perfil', element : <MiPerfilPage /> },
        { path : 'subscripcion', element : <SubscripcionPage /> },
        { path : 'comprar_folios', element : <ComprarFoliosPage /> },
        { path : 'video_tutoriales', element : <VideoTutorialesPage /> },
        { path: 'actualizaciones_sucursales', element: <ActualizacionesLocalesPage /> },
    ]
}

export default MainRoutes